import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Dropdown,
  Search,
} from '@makeably/creativex-design-system';
import { isDefined } from 'utilities/item';

const propTypes = {
  onSearch: PropTypes.func.isRequired,
  onSearchByChange: PropTypes.func,
  onSearchChange: PropTypes.func.isRequired,
  search: PropTypes.string.isRequired,
  searchBy: PropTypes.string,
};

const defaultProps = {
  onSearchByChange: undefined,
  searchBy: undefined,
};

const searchByOptions = [
  {
    label: 'Anything by ID',
    value: 'id',
  },
  {
    label: 'By Platform ID',
    value: 'platform_id',
  },
  {
    label: 'User by Name, Email',
    value: 'user',
  },
];

function ExplorerSearch({
  onSearch,
  onSearchChange,
  onSearchByChange,
  search,
  searchBy,
}) {
  const showSearchBy = isDefined(onSearchByChange);
  const searchByOption = searchByOptions.find(({ value }) => value === searchBy);
  const placeholder = `Search ${showSearchBy ? '' : (searchByOption?.label ?? '')}`;

  useEffect(() => {
    if (!searchByOption) {
      onSearchByChange?.(searchByOptions[0].value);
    }
  }, [searchByOption]);

  const handleKeyDown = (key) => {
    if (key === 'Enter') {
      onSearch();
    }
  };

  return (
    <div className="u-flexRow u-alignEnd u-gap-16">
      { showSearchBy && (
        <Dropdown
          label="Search For"
          menuProps={{ size: 'medium' }}
          options={searchByOptions}
          selected={searchByOptions.find(({ value }) => value === searchBy)}
          size="medium"
          onChange={(option) => onSearchByChange(option.value)}
        />
      ) }
      <Search
        placeholder={placeholder}
        size="large"
        value={search}
        onChange={onSearchChange}
        onKeyDown={handleKeyDown}
      />
      <Button
        disabled={search?.length === 0}
        label="Search"
        onClick={onSearch}
      />
    </div>
  );
}

ExplorerSearch.propTypes = propTypes;
ExplorerSearch.defaultProps = defaultProps;

export default ExplorerSearch;
